import React from "react";
import { Link } from "react-router-dom";
import groceryshop from "../images/Grocerylogo.png";
import "../Component/Footer.css"; // Style will be here

const Footer = () => {
  const year = new Date().getFullYear();
  

  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="footer-row">

          {/* Logo and Description */}
          <div className="footer-col">
            <Link to="/">
              <img src={groceryshop} alt="Logo" className="footer-logo" />
            </Link>
            <p className="footer-text">
  दर्जेदार वस्तू, विश्वासार्ह सेवा – आपल्या परिसरातील सखींचं दुकान!
</p>

            {/* <div className="payment-icons">
              {[amazonpay, american, mastercard, paypal, visa].map((src, i) => (
                <img key={i} src={src} alt="pay" className="payment-icon" />
              ))}
            </div> */}
          </div>

          {/* Area in Service */}
          <div className="footer-col">
         <h4><Link to="/areas" className="footer-title-link">Area in Service</Link></h4>

          </div>

          {/* Shop in Service */}
          <div className="footer-col">
              <h4><Link to="/shop-in-service" className="footer-title-link">Shop in Service</Link></h4>
          </div>

          {/* Discount Shop */}
          <div className="footer-col">
                          <h4><Link to="/discount-shop" className="footer-title-link">Discount Shop</Link></h4>

          </div>
            <div className="footer-col">
                          <h4><Link to="/customer-support" className="footer-title-link">Customer Support</Link></h4>

          </div>
        </div>

        {/* Copyright */}
        <div className="footer-bottom">
          <p>© {year} Sakhisshop. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
